export const S = {
    heading: 'Prediction-market implied policy rate',
    impliedFor: 'implied for',
    anchorToday: 'Anchor today',
    pricedIn: 'Priced in',
    nextMeeting: 'Next meeting',
    distribution: 'Distribution',
    anchorPlain: 'Anchor',
    basisBefore: 'Basis before the meeting',
    pricedMeeting: 'Meeting priced',

    decided: 'Decided',
    effectiveFrom: 'effective {d}',
    announcedOn: 'decided on {d}',
    notYetEffective: 'not yet effective',
    inForce: 'In force',

    hike: 'Hike',
    cut: 'Cut',
    hold: 'No change',
    decisionLikely: 'Expected decision',
    decisionMade: 'Decided',
    probability: 'probability',
    pricedThen: 'priced in at the time',
    pricedBefore: 'priced {t} before',
    pricedAt: 'Market at {d} UTC, {t} before the decision',
    expectedAt: 'Market now',
    minutes: '{n} min',
    hours: '{n} h',
    days: '{n} days',
    modal: 'Most likely outcome',
    meetingOn: 'Meeting on',

    r_1d: '1D',
    r_1w: '1W',
    r_1m: '1M',
    r_last: 'Last meeting',
    r_3m: '3 meetings',
    r_1y: '1Y',
    r_all: 'All',
    m_rate: 'Rate',
    m_delta: 'Change',
    history: 'History',
    today: 'now',
    asOfShort: 'as of',
    forward: 'expected',
    close: 'Close',
    decision: 'Decision',
    asOf: 'As of',
    times: 'Times in',

    errNetwork: 'The data could not be loaded. Please try again later.',
    errSchema: 'The data format has changed. Please reload the page.',
    errEmpty: 'There is no PIPR history in this time range.',
    aria: 'Prediction-market implied policy rate: history and expected path',

    openMarket: 'Open market',
    clickToOpen: 'click to open',
    noMarket: 'No market listed',
};

export type Strings = typeof S;
